import { enableProdMode, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { init_app } from './app/app.module';
import { environment } from './environments/environment';
import { AuthService } from './app/authentication/auth.service';
import { AppService } from './app/app.service';
import { DatePipe, DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { JwtService } from './app/core/services/jwt-service.service';
import { ConfirmationService } from 'primeng/api';
import { provideNgxMask } from 'ngx-mask';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './app/core/interceptors/auth-interceptor';
import { HttpErrorInterceptor } from './app/core/interceptors/http-error-interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { PrimeTheme } from './app/core/PrimeNGTheme';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppRoutingModule, ModalModule.forRoot()),
    AuthService,
    AppService,
    DatePipe,
    JwtService,
    ConfirmationService,
    provideNgxMask(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      const initializerFn = init_app(inject(AuthService));
      return initializerFn();
    }),
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { timezone: 'Asia/Kolkata' },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: PrimeTheme,
        options: {
          darkModeSelector: false, // or 'none' to completely disable automatic dark mode
        },
      },
    }),
  ],
}).catch((err) => console.error(err));
